import { useDomainConfig } from 'hooks/useDomainConfig';
import { useEffect, useState } from 'react';

type LocalizedDateProps = {
    date: string | Date;
    options?: Intl.DateTimeFormatOptions;
};

export const LocalizedDate: FC<LocalizedDateProps> = ({ date, options }) => {
    const { defaultLocaleIdentifier } = useDomainConfig();
    const [dateString, setDateString] = useState('');

    useEffect(() => {
        const parsedDate = new Date(date);

        setDateString(
            parsedDate.toLocaleDateString(defaultLocaleIdentifier, {
                timeZone: 'UTC',
                ...options,
            }),
        );
    }, [date, defaultLocaleIdentifier, options]);

    return <>{dateString}</>;
};
